// extracted by mini-css-extract-plugin
module.exports = {"Body":"card-body_Body__NP7SE"};